import { ApiResponse, GenericOperationState } from '@repo/core'
import { GlobalPositionResponse } from '@repo/position-types'
import { RootState } from '../../../store/types'

export const globalPositionSelectorConfig = {
  globalPositionSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<GlobalPositionResponse> | null> {
      return state.position.master.list.globalPosition
    },
  },
  globalPositionDownloadSelector: {
    getRootPath: (state: RootState) => state.position.master.list.globalPositionDownload,
  },
}
